import React from 'react';

export default (props) => (
    <div role="alert" className="alert alert-contrast alert-danger alert-dismissible">
        <div className="icon" role="button" data-dismiss="alert" > <span className="s7-attention"></span></div >
        <div className="message">
            {Array.isArray(props.message) ? 
              (props.message.length > 1 ? 
                <ul>{props.message.map((m, index) => <li key={index}>{m}</li>)}</ul> 
                : 
                props.message[0]) 
              : 
              props.message.toString()}
        </div>
    </div >
)


// WEBPACK FOOTER //
// ./src/components/Errors/Alert.js